import React from "react";
import Content from "../../layout/content/Content";

const PrivacyPolicy = () => {
  return <Content>Terms and Conditions</Content>;
};

export default PrivacyPolicy;
